import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import SocialPost from 'components/SocialPost';
import { useGetPostQuery } from 'services';
import { dataLimits } from 'constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from 'components/Common/Loader';
import useTranslate from 'hooks/useTranslate';
import useAuthStore from 'store/auth';
import '../styles.scss';

const MyFeeds: React.FC = () => {
	const { translate } = useTranslate();
	const [myFeeds, setMyFeeds] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const { token: isAuthenticated }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);

	const searchString = `order=DESC&page=${currentPage}&limit=${dataLimits?.feedsListing}&socialPostType=my-posts`;
	const {
		data: { docs: postList = {}, meta = {} } = {},
		status,
		isStale,
		refetch,
	} = useGetPostQuery({
		searchString: searchString,
		isFetch: currentPage,
		userToken: isAuthenticated,
	});

	const loadMoreFunc = () => {
		setCurrentPage((currentPage) => currentPage + 1);
	};

	useEffect(() => {
		if (
			status === 'success' &&
			postList &&
			Array.isArray(postList.results) &&
			postList.results.length > 0 &&
			isStale
		) {
			setMyFeeds((prev): any => [...prev, ...postList.results]);
		}
	}, [postList, status]);

	const refreshOnDeletePost = () => {
		refetch()
			.then((res: any) => {
				setMyFeeds(res?.data?.docs?.results);
			})
			.catch(() => {});
	};

	return (
		<div className="social-feed">
			<div className="social-feed-left">
				<Stack className="social-feed-posts">
					{myFeeds?.length > 0 ? (
						<InfiniteScroll
							dataLength={myFeeds.length}
							next={loadMoreFunc}
							hasMore={meta?.hasNextPage}
							loader={
								myFeeds.length >= 1 && (
									<div className="d-flex justify-content-center align-items-center">
										<Loader />
									</div>
								)
							}
							scrollableTarget={`infiniteDiv-social-feeds`}
							scrollThreshold="300px"
							refreshFunction={loadMoreFunc}
							pullDownToRefreshThreshold={50}
							pullDownToRefreshContent={
								<h3 style={{ textAlign: 'center' }}>
									&#8595; {translate('Common.pullDownToRefresh')}
								</h3>
							}
							releaseToRefreshContent={
								<h3 style={{ textAlign: 'center' }}>
									&#8593; {translate('Common.releaseToRefresh')}
								</h3>
							}
						>
							{myFeeds.length > 0 ? (
								myFeeds.map((post: any, index: number) => (
									<SocialPost
										post={post}
										key={`${post?.postId}-${post?.userId}-${index}`}
										refetch={refreshOnDeletePost}
										type={'myfeeds'}
									/>
								))
							) : (
								<Stack className="fw-bold">
									<p className="mb-0">{translate('Common.noPostFound')}</p>
								</Stack>
							)}
						</InfiniteScroll>
					) : (
						<div className="white-box bg-white">
							<Stack className="fw-bold">
								<p className="mb-0">{translate('Common.noPostFound')}</p>
							</Stack>
						</div>
					)}
				</Stack>
			</div>
		</div>
	);
};

export default MyFeeds;
